import {ScheduleService} from '@/common/api/schedule.service'
import {
    SCHEDULE_GET,
    TODAY_SCHEDULING_GET,
    SCHEDULE_START_ATTENDANCE,
    PAYMENT_TYPES_GET,
    SCHEDULE_ADD_ITEM,
    SCHEDULE_DELETE_ITEM,
    SCHEDULE_CREATE,
    SCHEDULE_CANCEL,
    SCHEDULE_FINISH_ATTENDANCE, SCHEDULE_BMS_SERVICES, SCHEDULE_ADD_ITEM_ASSISTANT, TODAY_SCHEDULING_GET_PAUSES
} from './actions/schedule.type'
import {
    SET_SCHEDULE,
    SET_TODAY_SCHEDULING,
    SET_TODAY_SCHEDULING_PAUSES,
    SET_PAYMENT_TYPES,
    SCHEDULE_RESET_STATE,
    SCHEDULE_REMOVE_SERVICE,
    SCHEDULE_ADD_SERVICE,
    SCHEDULE_CREATE_RESET_STATE,
    SET_SCHEDULE_BMS_SERVICES
} from './mutations/schedule.type'

import {
    CHANGE_PROGRESS
} from "./mutations/mutations.type"
import {ServiceService} from "@/common/api/service.service";


const initialState = () => {
    return {
        todayScheduling: {
            bms: [],
            schedules: [],
            start: "00:00",
            interval: 0
        },
        todaySchedulingPauses: {
            pauses: []
        },
        scheduleCreate: {
            personID: 0,
            date: null,
            services: [
                {
                    id: 0,
                    bmID: 0,
                    hour: null
                }
            ]
        },
        bmsServices: [[]],
        schedule: {
            id: 0,
            bmID: 0,
            bmName: "",
            serviceID: 0,
            serviceName: "",
            personID: 0,
            personName: "",
            statusID: 0,
            startTime: "",
            endTime: "",
            appUser: false,
            isSubscriptionUser: false,
            isPayingUser: false,
            isBirthday: false,
            isNewUser: false,
            createdAt: "",
        },
        paymentTypes: []
    }
}

export const state = initialState()

const getters = {
    schedule: state => {
        return state.schedule
    },
    paymentTypes: state => {
        return state.paymentTypes
    },
    todayScheduling: state => {
        return state.todayScheduling
    },
    todaySchedulingPauses: state => {
        return state.todaySchedulingPauses
    },
    scheduleCreate: state => {
        return state.scheduleCreate
    },
    bmsServices: state => {
        return state.bmsServices
    }

}

export const mutations = {
    [SET_SCHEDULE](state, data) {
        state.schedule = data
    },
    [SET_TODAY_SCHEDULING](state, data) {
        state.todayScheduling = data
    },
    [SET_TODAY_SCHEDULING_PAUSES](state, data) {
        state.todaySchedulingPauses.pauses = data
    },
    [SET_PAYMENT_TYPES](state, data) {
        state.paymentTypes = data
    },
    [SCHEDULE_RESET_STATE](state) {
        Object.assign(state, initialState())
    },
    [SCHEDULE_CREATE_RESET_STATE](state) {
        Object.assign(state.scheduleCreate, initialState().scheduleCreate)
    },

    [SCHEDULE_REMOVE_SERVICE](state, index) {
        state.scheduleCreate.services.splice(index, 1)
        state.bmsServices.splice(index, 1)
    },
    [SCHEDULE_ADD_SERVICE](state) {
        state.scheduleCreate.services.push({id: 0, bmID: 0, hour: null})
        state.bmsServices.push([])
    },
    [SET_SCHEDULE_BMS_SERVICES](state, data) {
        state.bmsServices.splice(data.index, 1, data.data)
    }
}

export const actions = {
    async [SCHEDULE_CREATE](_, data) {
        return ScheduleService.post(data);
    },
    async [SCHEDULE_CANCEL](_, id) {
        return ScheduleService.delete(id);
    },
    async [SCHEDULE_FINISH_ATTENDANCE](_, id) {
        return ScheduleService.finish_attendance(id);
    },
    async [SCHEDULE_ADD_ITEM](_, data) {
        return ScheduleService.addItem(data.id, data.item);
    },
    async [SCHEDULE_DELETE_ITEM](_, data) {
        return ScheduleService.deleteItem(data.orderID, data.itemID);
    },
    async [SCHEDULE_ADD_ITEM_ASSISTANT](_, data) {
        return ScheduleService.addItemAssistant(data.id, data.item);
    },
    async [PAYMENT_TYPES_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ScheduleService.get_payment_types()
        commit(SET_PAYMENT_TYPES, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [SCHEDULE_START_ATTENDANCE](_, id) {
        return ScheduleService.start_attendance(id);
    },
    async [SCHEDULE_BMS_SERVICES]({commit}, dt) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ServiceService.bmScheduleServices(dt.id)
        commit(SET_SCHEDULE_BMS_SERVICES, {index: dt.index, data: data})
        commit(CHANGE_PROGRESS, false)
    },
    async [SCHEDULE_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ScheduleService.get(id)
        commit(SET_SCHEDULE, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [TODAY_SCHEDULING_GET]({commit}, date = "") {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ScheduleService.get(date)
        commit(SET_TODAY_SCHEDULING, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [TODAY_SCHEDULING_GET_PAUSES]({commit}, date = "", bmID = "") {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ScheduleService.getDaysOff(date, bmID)
        commit(SET_TODAY_SCHEDULING_PAUSES, data)
        commit(CHANGE_PROGRESS, false)
    },
    [SCHEDULE_RESET_STATE]({commit}) {
        commit(SCHEDULE_RESET_STATE)
    }
}
export default {
    state,
    actions,
    mutations,
    getters
}
